<template>
	<div>
		<el-button type="primary" @click="batchProcessing" size="small" style="margin-bottom: 8px;" v-if="buttonShow">批量审批</el-button>
		<el-table :data="data" @selection-change="handleSelectionChange" ref="multipleTable">
	    <el-table-column
	      type="selection"
	      width="55"
				v-if="buttonShow">
	    </el-table-column>
			<el-table-column
				label="序号"
				type="index"
				width="50"
				fixed="left">
			</el-table-column>
			<el-table-column
				v-for="(item, index) in headerData"
				:key="index"
				:width="item.width">
				<template slot="header">
					<span v-if="item.required" style="color: red">*</span>
					<span class="header-field">{{ item.name }}</span>
				</template>
				<template slot-scope="scope">
					<!-- 显示不可编辑的表单状态
					情况： 1.不可编辑
								2.可以编辑、经销商/店铺当前活动已通过
								3.可以编辑、经销商/店铺当前活动被驳回，且大活动为审批中状态-->
					<el-row
						type="flex"
						v-if="!judgeCanEdit(scope.row.productresult)">
						<!-- 不是产品字段的字段，可以是自定义字段，可以是产品链接字段 -->
						<span v-if="item.key !== 'product_id' && item.key !== 'product_url' && item.key !== 'cashback' && item.key !== 'eachcashback' && item.key !== 'discounts'">
							{{ scope.row[item.key] || JSON.parse(scope.row.add_field)[item.key] }}
						</span>
						<span v-if="item.key === 'product_url'">
							<el-link
								class="cut-text"
								:href="scope.row['product_url']"
								:underline="false"
								type="primary"
								target="_blank">
							{{ scope.row['product_url'] }}
							</el-link>
						</span>
						<span v-if="item.key == 'cashback' || item.key == 'eachcashback' || item.key == 'discounts'">
							{{scope.row[item.key]}}
						</span>
						<!-- 产品字段，用的是productInfo -->
						<div v-if="item.key === 'product_id'">
							<el-row type="flex">
								<span>{{ scope.row['productInfo'] || scope.row['product_info'] }}</span>
								<!-- 在审批详情中显示 -->
								<el-popover
									v-if="needActivityState && scope.row.product_price"
									style="margin-left: 15px"
									placement="bottom"
									width="200"
									trigger="hover">
									<div
										v-for="(key, index) in Object.keys(scope.row.product_price)"
										:key="index"
									>
										<div v-if="scope.row.product_price[key]">{{ key }}: {{ scope.row.product_price[key] }}</div>
									</div>
									<i class="el-icon-warning-outline" slot="reference"></i>
								</el-popover>
							</el-row>
							<!-- <el-row v-if="data.details.campaignway == 0"> -->
							<el-row>
								<span style="color: #0000003f;" v-if="scope.row.shopproductcount">
									本店铺本品近90天已申报：{{scope.row.shopproductcount}}次
								</span>
								<span style="color: #0000003f;" v-else>
									本店铺本品近90天已申报：0次
								</span>
							</el-row>
						</div>
						<!-- 价格字段的违规标识 -->
						<el-popover
							v-if="mode === 0 && item.isPriceField && scope.row.breakdo_wnminimum && JSON.parse(scope.row.breakdo_wnminimum)[item.key] === '1'"
							class="g-inline-block"
							placement="top"
							trigger="hover"
							content="利润较低">
							<div slot="reference" class="name-wrapper">
								<i style="color:#F42730;" class="el-icon-warning"></i>
							</div>
						</el-popover>
					</el-row>
					<!-- 显示表单可以编辑
					情况： 可以编辑 并且 当前活动条数状态是驳回或是待审批状态 -->
					<div v-if="judgeCanEdit(scope.row.productresult)">
						<!-- 模式为按产品申报时，产品字段还是不可编辑，这是通过添加活动产品修改 -->
						<el-row v-if="item.key === 'product_id' && item.mode === 0" type="flex" justify="space-between">
							<span>
								{{ scope.row.productInfo }}
							</span>
							<el-popover placement="top" trigger="click">
								<div>
									<div v-for="item in $options.filters.objToAr(priceData)" style="padding-right: 10px;">
				            <span>{{item.name}}:{{item.val}}</span>
				          </div>
								</div>
								<i class="el-icon-warning-outline" slot="reference" v-if="scope.row.breakField && scope.row.productInfo.indexOf('空调') == -1" @click="getInfoByProductIds(scope.row)"></i>
						  </el-popover>
							<el-popover
								v-if="scope.row.product_price && needActivityState"
								placement="bottom"
								width="100"
								trigger="hover">
								<div v-for="(key, index) in Object.keys(scope.row.product_price)" :key="index">
									{{ key }}: {{ scope.row.product_price[key] }}
								</div>
								<i slot="reference" class="el-icon-warning-outline"></i>
							</el-popover>
						</el-row>
						<el-input
							v-if="item.key === 'product_id' && item.mode === 1"
							size="small"
							v-model.trim="scope.row.productInfo"
							placeholder="请输入内容">
						</el-input>
						<el-autocomplete
							v-if="item.key === 'product_url' && mode === 0 && !isInMyActivityPage"
							v-model.trim="scope.row.product_url"
							:style="getItemWidth(item.width)"
							size="small"
							@select="val => handleAutocompleteSelect(val, scope.$index)"
							:fetch-suggestions="(queryString, cb) => querySearch(queryString, cb, scope.$index)"
							placeholder="请输入内容">
							<template slot-scope="{ item }">
								<div class="name">{{ item }}</div>
							</template>
						</el-autocomplete>
						<el-input
							v-if="item.key === 'product_url' && (item.mode === 1 || isInMyActivityPage)"
							size="small"
							v-model.trim="scope.row.product_url"
							placeholder="请输入链接">
						</el-input>
						<!-- 不是活动链接、产品型号的非价格字段 -->
						<el-input
							v-if="item.key !== 'product_url' && item.key !== 'product_id' && !item.isPriceField"
							size="small"
							v-model.trim="scope.row[item.key]"
							:style="getItemWidth(item.width)"
							placeholder="请输入">
						</el-input>
						<!-- 不是活动链接、产品型号的价格字段 -->
						<div v-if="item.key !== 'product_url' && item.key !== 'product_id' && item.isPriceField">
							<el-input-number
								size="small"
								:style="getItemWidth(item.width, true)"
								v-model="scope.row[item.key]"
								@blur="onInputBlur(item.key, scope.$index)"
								:min="0.01"
								:max="999999999999"
								:precision="2"
								:controls="false"
								placeholder="请输入">
							</el-input-number>
							<!-- 如果违规，显示违规标识 -->
							<el-popover
								v-if="scope.row.breakField && scope.row.breakField[item.key] === '1'"
								class="g-inline-block"
								placement="top"
								trigger="hover"
								content="利润较低">
								<div slot="reference" class="name-wrapper">
									<i style="color:#F42730;" class="el-icon-warning"></i>
								</div>
							</el-popover>
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column
				width="100"
				label="审批状态"
				v-if="needActivityState"
				fixed="right"
				>
				<template slot-scope="scope">
					<!-- 审批状态组件 -->
					<ActivityState :state="scope.row.campaign_node"/>
				</template>
			</el-table-column>
			<!-- 活动模板并且在可编辑状态下  或者  不是活动模板页面 -->
			<el-table-column
				fixed="right"
				v-if="(isInTemplate && canEdit) || !isInTemplate"
				:width="needActivityState ? '300' : !canEdit ? '200' : (canEdit && isInMyActivityPage) ? '200' : ''"
				:label="needActivityState ? '审批操作' : !canEdit ? '审批结果' :  '操作'">
				<template slot-scope="scope">
					<!-- 品牌方活动审批详情审批操作使用 -->
					<ActivityApprovalOperate
						v-if="needActivityState"
						:data="scope.row"
					/>
					<!-- 申报活动、我的活动使用 -->
					<slot v-else name="operate" :data="scope"></slot>
				</template>
			</el-table-column>
			<!-- 这个是解决表格字段少，导致表格不能填充全屏的问题，使用空列自适应并补充剩余空间 -->
			<el-table-column
				v-if="(!isInTemplate && !canEdit) || isInTemplate"
				label=""
			>
			</el-table-column>
		</el-table>
		<!-- 批量设置通知人 -->
		<el-dialog
			title="批量审批"
			:visible.sync="processingShow"
			:close-on-click-modal="false"
			width="640px">
			<el-row style="box-sizing: border-box;max-height: 595px;overflow:auto;">
				<div class="seaerch-wrapper">
					<el-form label-width="100px">
						<el-form-item label="审批" :required="true">
							<el-button
								icon="el-icon-circle-check"
								size="mini"
								:type="buttonType1"
								@click="changeType(1)">
								通过
							</el-button>
							<el-button
								icon="el-icon-refresh-left"
								size="mini"
								:type="buttonType2"
								@click="changeType(2)">
								驳回
							</el-button>
						</el-form-item>
						<el-form-item label="审批说明">
							<el-input
							  type="textarea"
							  :rows="4"
							  placeholder="请输入"
							  v-model="examineView">
							</el-input>
						</el-form-item>
						<el-form-item label="下级审批人" v-if="newType.logintype !== 'HCM' && titleDataShow && this.buttonType1">
							<el-select v-model="subordinateUserid" multiple placeholder="请选择" size="mini" style="width: 440px;" @change="savaCampaignTags(subordinateUserid)">
								<el-option
									v-for="item in dataOptions"
									:key="item.value"
									:label="item.title"
									:value="item.value">
								</el-option>
							</el-select>
							<div style="color: rgba(0, 0, 0, 0.247);font-size: 12px;">
								如需下一级审批，请选择审批人。未选择则至本级审批完结。
							</div>
							<div style="float: left;" v-for="item in buttonArr" v-if="buttonArr && buttonArr[0].tags">
								<el-button type="success" plain size="mini" style="margin-bottom: 16px;margin-right: 8px;" @click="buttonClick(item)" :disabled="item.disabled">{{item.tags}}</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</el-row>
			<span slot="footer">
				<el-button size="small" class="g-confirm-btn" @click="processingClick" :loading="notifyLoading">确 定</el-button>
				<el-button size="small" class="g-cancel-btn" @click="processingShow = false">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import _ from 'lodash';
import { handleProductUrl } from '@/libs'
import ActivityApprovalOperate from '../activityOperate/activityApprovalOperate';
import ActivityState from "components/activityState/activityState";
import { mapGetters, mapActions } from 'vuex';
import aes from "@/libs/aes";
export default {
	name: 'activityTable',

	components: {
		ActivityState,
		ActivityApprovalOperate
	},

	props: {
		titleData: {
			type: Object,
		},
		// 这个状态相当于在活动审批详情页的标识
		needActivityState: {
			type: Boolean,
			default: false
		},
		isInTemplate: {
			type: Boolean,
			default: false
		},
		isInMyActivityPage: {
			type: Boolean,
			default: false
		},
		// 可以编辑的标识
		canEdit: {
			type: Boolean,
			default: false
		},
		data: {
			type: Array,
			required: true,
			default: () => {}
		},
		headerData: {
			type: Array,
			required: true
		},
		mode: {
			type: Number,
			default: 0
		},
		shopname: {
			type: String
		},
	},

	data () {
		return {
			titleDataShow: false,
			dataOptions: [],
			newType: {},
			buttonArr: [],
			subordinateUserid: [],
			priceData: {},
			buttonShow: false,
			examineResult: '',
			buttonType1: '',
			buttonType2: '',
			examineView: '',
			notifyLoading: false,
			turnData: [],
			processingShow: false,
			deleteFields: [
				'id',
				'hid',
				'shop_id',
				'product_info',
				'campaignway',
				'campaign_node',
				'add_field',
				'breakField'
			],
			// 排除不添加到addField的字段
			excludeAddFields: [
				'breakdo_wnminimum',
				'breakdostate',
				'apply_price',
				'actual_price',
				'sales',
				'estimated_sales',
				'product_id',
				'productInfo',
				'product_url',
				'breakField',
				'campaign_node',
				'campaignExamine',
				'productresult',
				'discounts'
			],
			showLowPrice: {},
			productLink: [],
			cascaderProps: {
				value: 'id',
				label: 'productClassifyName'
			},
			multipleSelection: [],
			test: 2,
		}
	},
	filters: {
    objToAr: aes.objToArr
  },
	methods: {
		// 保存标签
		savaCampaignTags(item) {
			let tagsArr = []
			for (let a in item) {
				for (let b in this.dataOptions) {
					if (item[a] == this.dataOptions[b].value) {
						tagsArr.push(this.dataOptions[b].title)
					}
				}
			}
			let data = {
				userid: item.join(','),
				tags: tagsArr.join(','),
			}
			if (this.tagId) {
				data.id = this.tagId
			}
			fetch({
				url: "hcm/campgign/savaCampaignTags",
				method: "post",
				data: JSON.stringify(data),
				headers: {
					'Content-Type': 'application/json',
				},
				noFormat: false,
				responseType: "json"
			}).then((res) => {
				if(res.status === '10000') {
					this.getCampaignTagsdetils()
				} else {
					this.$message.error(res.message);
				}
			}).catch(err => {
				this.$message.error('服务器出错');
			})
		},
		// 获取下级审批人
		getUserTreeByCampaignId() {
			let params = {
				cproIds: this.titleData.hid
			}
			fetch({
        url: "hcm/userout/getUserTreeByCampaignId",
        method: "get",
        noFormat: true,
				params: params,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
					this.dataOptions = []
					for (let a in data) {
						for (let b in data[a].children) {
							this.dataOptions.push(data[a].children[b])
						}
					}
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      }).catch(err => {
				this.$message.error('服务器出错');
			})
		},
		buttonClick(item) {
			for (let b in this.buttonArr) {
				if (this.buttonArr[b].userid == item.userid) {
					this.subordinateUserid.push(Number(item.userid))
					this.buttonArr[b].disabled = true
				}
			}
		},
		// 标签回显
		getCampaignTagsdetils() {
			fetch({
        url: "hcm/campgign/getCampaignTagsdetils",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
					this.buttonArr = []
					if (data) {
						this.tagId = data.id
						let dataTagsArr = data.tags.split(',')
						let dataUserid = data.userid.split(',')
						let newData = []
						for (let a in dataUserid) {
							newData.push({
								tags: dataTagsArr[a],
								userid: dataUserid[a],
								disabled: false
							})
						}
						for (let c in newData) {
							for (let d in this.dataOptions) {
								if (newData[c] == this.dataOptions[d].value) {
									newData[c].disabled = true
								}
							}
						}
						this.buttonArr = newData
						for (let b in this.buttonArr) {
							for (let e in this.subordinateUserid) {
								if (this.buttonArr[b].userid == this.subordinateUserid[e]) {
									this.buttonArr[b].disabled = true
								}
							}
						}
					}
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      }).catch(err => {
				this.$message.error('服务器出错');
			})
		},
		changeType(e) {
			if (e == 1) {
				this.buttonType1 = 'success'
				this.buttonType2 = ''
				this.buttonType3 = ''
				this.examineResult = 1
			} else if (e == 2) {
				this.buttonType1 = ''
				this.buttonType2 = 'warning'
				this.buttonType3 = ''
				this.examineResult = 2
			}
		},
		processingClick() {
			if (!this.examineResult) {
				this.$message({
          message: '请选择审批',
          type: 'warning'
        });
				return;
			}
			this.notifyLoading = true
			let campaignId = ''
			let camProId = []
			if (this.multipleSelection.length > 0) {
				for (let a in this.multipleSelection) {
					if (this.multipleSelection[a].campaign_node == '待审批') {
						campaignId = this.multipleSelection[0].id
						camProId.push(this.multipleSelection[a].hid)
					}
				}
			}
			let data = {
				examineResult: this.examineResult,
				time: this.$options.filters.fullTime(this.titleData.updatetime),
			}
			if (campaignId) {
				data.campaignId = campaignId
			}
			if (camProId.length != 0) {
				data.campainproids = camProId.join(',')
			}
			if (this.examineView) {
				data.examineView = this.examineView
			}
			if (this.subordinateUserid) {
				data.subordinateUserid = this.subordinateUserid.join(',')
			}
			fetch({
				url: "hcm/campgign/saveCamExamineall",
				method: "post",
				params: data,
				noFormat: true,
				responseType: "text",
				timeout: 60000000 * 5000
			}).then(result => {
				let res = JSON.parse(result);
				let {data}=res
				if(res.status == '10000'){
					this.notifyLoading = false
					this.$message({
	          message: res.message,
	          type: '成功'
	        });
					this.processingShow = false
					this.load();
				} else {
					this.$message.error(res.message);
				}
			})

		},
		// 重新加载详情页数据
		load() {
			this.reqActivityDetail({
				id: this.$route.params.id
			}).then(() => {

			})
		},
		getInfoByProductIds(row) {
			let params={
        id: row.product_id,
      }
      fetch({
        url: "hcm/hcmProduct/getInfoByProductIds",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
					console.log(data)
					if (data && data[0].price) {
		        this.priceData = data[0].price
		      }
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      }).catch(err => {
				this.$message.error('服务器出错');
			})
		},
		getAllUserTreeByDepartId() {
			fetch({
				url: "hcm/userout/getAllUserTreeByDepartId",
				method: "get",
				noFormat: true,
				responseType: "text"
			}).then(result => {
				let res = JSON.parse(result);
				let {data}=res
				if(res.status == '10000'){
					this.turnData = []
					if (data && data.length > 0) {
						for (let a in data) {
							if (data[a].children && data[a].children.length > 0) {
								for (let i in data[a].children) {
									this.turnData.push(data[a].children[i])
								}
							}
						}
					}
				} else {
					this.$message.error(res.message);
				}
			})
			.catch(err => {
				this.$message.error('服务器出错');
			})
		},
		batchProcessing() {
			console.log(this.data)
			this.examineView = ""
			this.examineResult = ''
			this.buttonType1 = ''
			this.buttonType2 = ''
			this.buttonType3 = ''
			if (this.multipleSelection.length == 0) {
				this.$message({
          message: '请选择产品',
          type: 'warning'
        });
				return
			}
			this.processingShow = true
		},
		handleSelectionChange(val) {
      this.multipleSelection = val;
			console.log(val)
    },
		judgeCanEdit(currentItemResult) {
			if(this.canEdit) {
				if(!this.isInMyActivityPage){
					return true;
				}else {
					if(this.getActivityInfoDetail.details.campaign_node === '审批中' && !currentItemResult){
						return true;
					}else if(this.getActivityInfoDetail.details.campaign_node === '已审批' && currentItemResult === '2') {
						return true;
					}else if(this.getActivityInfoDetail.details.campaign_node === '待审批') {
						return true;
					}
				}
			}

			return false;
		},
		// 遍历每个输入框 验证表格
		validTable() {
			for(const field of this.headerData) {
				if(!this.data.length) {
					this.$message.error(`请添加产品`);
					return false;
				}
				if(field.required) {
					for(const item of this.data) {
						if(field.key === 'product_id' && field.mode === 1) {
							continue;
						}
						if(!item[field.key]) {
							this.$message.error(`请输入${field.name}`);
							return false;
						}
					}
				}
			}
			return true;
		},
		// 获取add_field
		getProductAddFidld(product) {

			let add_field = {};
			for(let i in product) {
				if(!this.excludeAddFields.includes(i)) {
					add_field[i] = product[i];
				}
			}
			return add_field;
		},
		getBreakdostate(fieldObj) {

			for(let i in fieldObj) {
				if(fieldObj[i] == 1) {
					return 1;
				}
			}
			return 0;
		},
		// 清除为空的数据
		clearNullAndUndefined(item) {
			for(const key of Object.keys(item)) {
				if(item[key] === null || item[key] === undefined) {
					delete item[key];
				}
			}
		},
		// 获取表格数据
		getTableData(needProductLink) {
			const urlRe = /(http|https):\/\/([\w.]+\/?)\S*/;
			const data = _.cloneDeep(this.data);
			console.log(this.data);

			let res = [];
			for(const item of data) {
				if(this.mode === 0) {
					if(item.breakField) {
						item.breakdo_wnminimum = JSON.stringify(item.breakField);
					}
				}
				item.breakdostate = this.getBreakdostate(item.breakField);
				for(const field of this.deleteFields) {
					delete item[field];
				}
				if(!needProductLink) {
					delete item['productLink'];
				}
				// 对是http的链接做截取为短链接
				if(this.mode === 1 && urlRe.test(item['product_url'])) {
					item['product_url'] = handleProductUrl(item['product_url'])
				}
				this.mode === 1 && (delete item['product_id'])
				console.log(_.cloneDeep(item));

				item.add_field = JSON.stringify(this.getProductAddFidld(item));
				this.clearNullAndUndefined(item);
				res.push(item);
			}

			res = this.filterHasPassedCplistData(res);
			console.log('====================================');
			console.log(_.cloneDeep(res));
			console.log('====================================');
			return res;
		},
		// 我的活动重新填写时，过滤已经通过的数据
		filterHasPassedCplistData(data) {
			return data.filter(item => (item.productresult === '2' || !item.productresult))
		},
		async onInputBlur(key, index) {
			if(this.data[index][key] && this.mode === 0) {
				const params = {
					price: this.data[index][key],
					product_id: `${this.data[index].product_id}`
				}
				const res = await this.reqIsLowPrice(params)
				if(this.data[index].breakField[key]) {
					this.data[index].breakField[key] = res;
				}else {
					this.$set(this.data[index].breakField, key, res);
				}
			}
		},
		createFilter(queryString) {
			return (restaurant) => {
				return (restaurant.toLowerCase().indexOf(queryString.toLowerCase()) !== -1);
			};
		},
		querySearch(queryString, cb, index) {
			let restaurants = this.data[index].productLink;
			let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
			// 调用 callback 返回建议列表的数据
			cb(results);
		},
		handleAutocompleteSelect(value, index) {
			this.data[index].product_url = value;
		},
		getItemWidth(width, isPriceField) {
			return isPriceField ? `width: ${width- 50}px` : `width: ${width - 10}px`
		},
		handleFilterMethod(node, keyword) {
			return node.text.toUpperCase().indexOf(keyword.toUpperCase()) !== -1;
		},
		...mapActions([
			'reqShopProductLink',
			'reqIsLowPrice',
			'reqActivityDetail'
		]),
	},
	watch: {
    data(val,oldVal){
			this.data = val
			let type = JSON.parse(window.localStorage.userData);
			if (type.logintype.indexOf('HCMSUB') == 0) {
				for (let a in this.data) {
					if (this.data[a].campaign_node == "待审批") {
						this.buttonShow = true
					}
				}
			} else if (type.logintype != "SHOP" && type.logintype != "DEALER") {
				for (let a in this.data) {
					if (this.data[a].campaign_node == "待审批" && this.data[a].bmcstatus && this.data[a].bmcstatus === '1') {
						this.buttonShow = true
					}
				}
			}
			if (this.titleData) {
				if (this.titleData.campaignmodel == 1) {
					this.titleDataShow = true
				} else {
					this.titleDataShow = false
				}
				this.getUserTreeByCampaignId(this.titleData.hid)
				this.getCampaignTagsdetils()
			}

    },
  },

	computed: {
		...mapGetters([
			'getDealerShops',
			'getShopProducts',
			'getProductLink',
			'getActivityInfoDetail'
		]),
	},

	updated() {
		// console.log(this.data);
	},

	mounted(){
		this.newType = JSON.parse(window.localStorage.userData);
		this.getAllUserTreeByDepartId()

	}
}
</script>

<style lang="scss">
.el-table th>.cell {
	color: black;
	font-weight: bold;
}

.el-table th {
	background-color: #F2F6FE;
}

.g-inline-block {
	display: inline-block;
	margin-left: 10px;
}

.cut-text {
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}

</style>
